import init from "./init";
import logEvent from './logEvent'
import type { LoggingEvent } from './logEvent'

/**
 * Logs a user following a link to location within the site
 * * Only run on clientside
 * @param location A label that decribes the link for easy reference
 * @param to The location the user is being sent to
 */

const mapLinkClick = () => {
  // UA
  init();

  let layerUpdate: LoggingEvent = { event: "show_map", location: "map"  };
  logEvent(layerUpdate);
};

export default mapLinkClick;
